import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand extends BasicCommand<UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand> {
    get primaryKey(): IPrimaryKey<UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    produktionsmallId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand";
    constructor(init: (instance: UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand) => void) {
        super(UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand.$type,
            UtbytessimuleraFromVirkeskopskontraktWithProduktionsmallCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
